import {PlayCircleFilled, PlayCircleOutlined, StarFilled,} from '@ant-design/icons'
import {Avatar, Input} from 'antd'
import classNames from 'classnames'
import {AppTextLogoIcon} from 'components/icons/AppTextLogoIcon'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import {LoginContext} from 'components/LoginContext'
import getAvatar from 'helpers/getAvatar'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useContext, useEffect, useState} from 'react'
import {BiSolidChurch} from 'react-icons/bi'
import {RiSearch2Line} from 'react-icons/ri'
import {Link, NavLink} from 'react-router-dom'
import {useLocation} from 'react-use'
import {withProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {HeaderButton} from 'views/Organization/components/PageHeader'
import {SearchTypes} from 'views/Search/SearchProvider'
import {NullAsDefault, renderElse, renderFalse, renderIf, renderSelf,} from 'views/Shared'
import {useDrawerDetector} from 'views/Shared/components/CustomSiderMenu'
import {Queries} from 'views/Shared/enums/Queries'
import {LocalContext} from '../../modules/local/LocalContext'
import HeaderNavigation from './HeaderNavigation'
import {auth_getMyJoinedOrganization_Api} from "../../apis";
import {API_ROOT_URL, IS_CORDOVA} from "../../envs/_current/config";
import getLinkToDetail from "../../helpers/getLinkToDetail";
import {BsThreeDots} from "react-icons/bs";
import {AsyncWithCache} from "../../modules/asyncCache/components/Async";
import {TbMenu2} from "react-icons/tb";
import {SystemPermission} from "../../components/RequiredAdmin";
import {routePathStartsWith} from "../../envs/_current/history";
import {SupportSvg} from "../../components/Svgs/SupportSvg";
import GoBackAction from "../AppLocals/custom/GoBackAction";
import UpdateBanner from "./UpdateBanner";
import {GoHomeFill} from "react-icons/go";
import {HiMiniUserGroup} from "react-icons/hi2";
import {isIOS} from "../../envs/environment";
import {getAppVersionSafe, useAppConfig} from "../../modules/local";
import {MdNewspaper} from "react-icons/md";
import {AppLogoSvg} from "../../appConfigs/svgs/AppLogoSvg";
import useScrollHide from "../../hooks/useScrollHide";
import {ShoppingIconSvg} from "../../components/Svgs/ShoppingIconSvg";

const HeaderToggleOptions = Object.freeze({
    MYSPACE: {
        label: 'Dashboard',
        path: staticPaths.home,
    },
    WORKSPACE: {
        label: 'workspace',
        path: staticPaths.workspace,
        isInvisble: (login, __) => Boolean(!_.get(login, 'primary_org')),
    },
    STARTSPACE: {
        label: 'start',
        path: staticPaths.start,
    },
})

export const DrawerHeader = () => {
    const {toggle = NullAsDefault, hasDrawer = false} = useDrawerDetector()

    const {visibleLeftDrawer} = useContext(LayoutContext)

    const showDrawer = Boolean(visibleLeftDrawer && hasDrawer)

    return (
        showDrawer && (
            <HeaderButton
                width={30}
                height={30}
                icon={<TbMenu2 size={14}/>}
                onClick={() => toggle(true)}
            />
        )
    )
}

const HeaderWrapper = ({children, className, Component = 'header'}) => (
    <Component className={className}>
        <div className="flex background-100 items-center">
            <div className="w-full flex flex-wrap items-center justify-between px-3">
                {children}
            </div>
        </div>
    </Component>
)

const StarterNav = ({path, label, isInvisble = renderFalse}) => {
    const t = useTranslate()

    const {isLg} = useContext(LayoutContext)

    const location = useLocation()

    const isActive = location.pathname === _.get(path, 'pathname')

    const Icon = isActive ? PlayCircleFilled : PlayCircleOutlined

    return renderElse(
        isInvisble(true),
        <nav
            style={{
                borderRadius: '0 0 0 20px',
                height: 'var(--header-height)',
                boxShadow: ' inset -4px -10px 9px -5px var(--border-color-base)',
            }}
            className="w-full flex-1 flex background-100 noSrollbar overflow-auto"
            id="headernav">
            <NavLink
                to={path}
                activeClassName="text-primary font-medium border-current px-3"
                tabIndex={3}
                style={{
                    borderRadius: '-0.25rem',
                }}
                isActive={(match, location) =>
                    location.pathname === _.get(path, 'pathname')
                }
                className={classNames(
                    'flex items-center px-1 space-x-2 font-normal flex-shrink-0 truncate border-transparent',
                    'md:border-b-4 hover:opacity-75 focus:outline-none'
                )}>
                <div
                    className={classNames(
                        'border-5 rounded-full flex items-center justify-center',
                        'text-color-300'
                    )}>
                    <Icon
                        className={classNames(
                            'text-3xl',
                            isActive ? 'text-primary' : 'text-color-500'
                        )}
                    />
                </div>
                <div>{Boolean(isLg) && t(label)}</div>
            </NavLink>
            <div className="flex flex-1 justify-end">
                <LoginNow/>
            </div>
        </nav>
    )
}

const LoginNow = () => {
    const t = useTranslate()
    const history = useHistory()
    const login = useContext(LoginContext)
    if (login) return null
    return (
        <div
            onClick={() => {
                history.push(staticPaths.login)
            }}
            className="flex items-center h-full text-white bg-primary px-2 cursor-pointer">
            {t('Login now')}
        </div>
    )
}

export const ToggleHeader = ({
                                 children,
                                 options = [HeaderToggleOptions.MYSPACE, HeaderToggleOptions.WORKSPACE],
                             }) => {
    const t = useTranslate()

    const login = useContext(LoginContext)

    const location = useLocation()

    return (
        <HeaderWrapper>
            {children}
            <div
                style={{
                    height: 'var(--header-height)',
                    borderRadius: `0px 20px 0px 0px`,
                    boxShadow: 'var(--border-color-base) 4px 10px 9px -5px inset',
                }}
                className="flex space-x-1 flex-shrink-0 cursor-pointer items-center justify-center truncate background-100">
                {Array.from(options || []).map(
                    (
                        {label, isInvisble = renderFalse, path = staticPaths.home},
                        index
                    ) => {
                        const _currentPath = path.pathname
                        const isActive = routePathStartsWith(location, _currentPath)
                        return renderElse(
                            isInvisble(login),
                            <NavLink
                                key={index}
                                className="flex flex-wrap items-center"
                                to={path}>
                                <Avatar
                                    size={40}
                                    shape="circle"
                                    className={classNames(
                                        'background-100 m-1 text-color-500 flex-shrink-0 flex items-center justify-center border-5 rounded-full border-blue-100',
                                        isActive && 'border-blue-400 text-blue-500 bg-blue-500'
                                    )}
                                    style={
                                        isActive
                                            ? {
                                                color: '#4172d6',
                                            }
                                            : {
                                                borderColor: 'var(--text-color-500)',
                                            }
                                    }
                                    icon={<StarFilled/>}
                                />
                                {isActive && (
                                    <div className="flex pl-1 pr-2 font-bold text-blue-500 no-underline">
                                        {t(label)}
                                    </div>
                                )}
                            </NavLink>
                        )
                    }
                )}
            </div>
            <StarterNav {...HeaderToggleOptions.STARTSPACE} />
        </HeaderWrapper>
    )
}


export const ShortCutsWidget = () => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const {isSm} = useContext(LayoutContext)
    const history = useHistory()

    const apiPath = auth_getMyJoinedOrganization_Api.path;
    const path = apiPath + '?filter=member&sort_by=recently'

    return (
        <div style={{height: 36}} className="flex items-center gap-x-3">
            <div style={{paddingBottom: 2}}
                 className="flex items-center flex-1 gap-x-2 overflow-y-hidden overflow-auto scrollBarThin">
                {renderIf(
                    login,
                    <AsyncWithCache
                        cacheId={path}
                        apiInfo={{
                            root: API_ROOT_URL,
                            path: path,
                            method: 'GET',
                        }}>
                        {({result, response}) => {
                            const login_id = login?.primary_org?.id;
                            const len = isSm ? 6 : 2; // Nếu mobile thì hiển thị 6 cái, còn desktop thì hiển thị 2 cái
                            const memberOrgs = _.get(response, 'data.data', []).filter(e => e.id !== login_id);
                            const defaultList = memberOrgs.slice(0, len);

                            return renderIf(
                                defaultList?.length,
                                defaultList.map((e, i) => (
                                    <Link key={i} to={getLinkToDetail(e)}>
                                        <Avatar
                                            size={30}
                                            className="flex flex-center background-100 border rounded-md cursor-pointer"
                                            src={getAvatar(e)}
                                            icon={<BiSolidChurch size={18} className="text-color-500"/>}
                                        />
                                    </Link>
                                ))
                            )
                        }}
                    </AsyncWithCache>
                )}
            </div>
            <Link style={{paddingBottom: 4}} to={`${staticPaths.discovery.pathname}?type=organization`}>
                <Avatar.Group shape="square" size={30} maxCount={3} className="flex items-center">
                    <Avatar
                        size={30}
                        style={{border: '1px solid #d9d9d9'}}
                        className="flex flex-center background-100 rounded-md cursor-pointer"
                        icon={<BiSolidChurch size={16} className="text-color-500"/>}
                    />
                    <Avatar
                        size={28}
                        className="flex flex-center cursor-pointer custom-show-more-org border border-color-50"
                        icon={<BsThreeDots size={14} className="text-color-500"/>}
                    />
                </Avatar.Group>
            </Link>
            {renderIf(
                isSm,
                <SystemPermission system={true}>
                    {(isAdmin) => (
                        <Link to={isAdmin ? '/feedbacks' : '/feedbacks/add-request?category=others'}>
                            <Avatar
                                size={30}
                                // style={{border: '1px solid #d9d9d9'}}
                                shape={"circle"}
                                className="flex flex-center bg-orange-50 hover:bg-orange-100 border border-orange-200 rounded-full cursor-pointer"
                                icon={<SupportSvg size={16} className="text-orange-500"/>}
                            />
                        </Link>
                    )}
                </SystemPermission>
            )}
        </div>
    )
}

export const SearchWidget = ({type = SearchTypes.KEYWORD}) => {
    const t = useTranslate()
    const history = useHistory()
    const searchParams = new URLSearchParams({type})
    return (
        <Input
            allowClear={true}
            prefix={<RiSearch2Line className="text-color-400"/>}
            placeholder={t('type to search')}
            className="custom-search-header rounded-full"
            onKeyDown={(event) => {
                const {value: keyword} = event.target
                if (_.isEmpty(keyword)) {
                    return
                } else if (event.key === 'Enter') {
                    searchParams.set(Queries.KEYWORD, keyword)
                    if (type === SearchTypes.BIBLES) {
                        history.push({
                            pathname: staticPaths.bibles.pathname,
                            search: '?' + searchParams.toString(),
                        })
                    } else {
                        history.push({
                            pathname: staticPaths.discovery.pathname,
                            search: '?' + searchParams.toString(),
                        })
                    }
                }
            }}
        />
    )
}

const AppTabs = () => {
    const t = useTranslate();
    const location = useLocation();

    // Hàm kiểm tra tab có đang active hay không dựa trên pathname
    const checkActive = (path) => {
        if (path === 'home') return location.pathname === '/' || location.pathname === '/home';
        return location.pathname.startsWith(`/${path}`);
    };

    const tabs = [
        {id: 'home', icon: GoHomeFill, label: t("home"), path: staticPaths.home.pathname},
        {id: 'news', icon: MdNewspaper, label: t("catholic news"), path: staticPaths.news.pathname},
        {id: 'apps', icon: AppLogoSvg, label: t("applications"), path: staticPaths.apps.pathname},
        {id: 'products', icon: ShoppingIconSvg, label: t("products"), path: staticPaths.products.pathname},
        {id: 'groups', icon: HiMiniUserGroup, label: t("groups"), path: staticPaths.groups.pathname},
    ];

    return (
        <div className="flex items-center justify-center w-full">
            <div className="flex w-full">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    const isActive = checkActive(tab.id);

                    return (
                        <Link
                            key={tab.id}
                            to={tab.path}
                            className="relative flex flex-1 items-center justify-center group"
                            title={tab.label}
                        >
                            <div className={`
                                flex items-center justify-center w-[90%] h-[90%] rounded-xl transition-all duration-200
                                ${isActive ? 'text-blue-600' : 'text-gray-500 hover:bg-gray-100'}
                            `}>
                                <Icon size={28}/>
                            </div>
                            {
                                isActive && (
                                    <div
                                        className="absolute bottom-0 left-0 right-0 h-[3px] bg-blue-600 rounded-t-full"/>
                                )
                            }
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};


const compareVersion = (v1, v2) => {
    const a = v1.split('.').map(Number);
    const b = v2.split('.').map(Number);

    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const diff = (a[i] || 0) - (b[i] || 0);
        if (diff !== 0) return diff;
    }
    return 0;
}

export const LogoHeader = ({
                               style,
                               className,
                               LogoIcon = AppTextLogoIcon,
                               isSubPage = true
                           }) => {
    const {lang} = useContext(LocalContext)
    const {appsConfigVersion = {}} = useAppConfig()
    const platform = isIOS() ? 'ios' : 'android';
    const osConfig = appsConfigVersion[platform];
    const [showUpdateInfo, setShowUpdateInfo] = useState({show: false});

    useEffect(() => {
        if (IS_CORDOVA) {
            getAppVersionSafe().then(appVersion => {
                if (!appVersion) return; // web hoặc chưa cài plugin
                console.log('App version:', appVersion);

                if (compareVersion(appVersion, osConfig?.latest) < 0) {
                    setShowUpdateInfo(
                        {show: true, force: osConfig.force, url: osConfig.storeUrl}
                    );
                }
            });
        }
    }, [])


    const {isLg, isMd, isSm} = useContext(LayoutContext)

    return (
        <div
            style={style}
            className={classNames('w-full', className)}>
            <div className="w-full px-3 flex flex-row items-center border-b border-color-50 shadow-xs relative">

                {!isLg && isSubPage && (
                    <div
                        className="flex flex-shrink-0 px-2 gap-1 md:gap-3 stickyTop background">
                        <GoBackAction/>
                    </div>
                )}

                <div className="mr-auto">
                    <LogoIcon to={staticPaths.home}/>
                </div>

                {!!isLg && (
                    <div
                        className="header-center-absolute"
                        style={{height: 'var(--header-height)'}}
                    >
                        <AppTabs/>
                    </div>
                )}

                {!!isLg && (
                    <div style={{maxWidth: 180}}>
                        <SearchWidget type={SearchTypes.BIBLES}/>
                    </div>
                )}

                {!isLg && !isSubPage ? <HeaderNavigation/> : <div/>}
                {!isLg && isSubPage && <DrawerHeader/>}
            </div>
            {IS_CORDOVA && showUpdateInfo?.show && (
                <UpdateBanner
                    force={showUpdateInfo?.force}
                    storeUrl={showUpdateInfo?.url}
                    onClose={() => {
                        setShowUpdateInfo({show: false})
                    }}
                />
            )}
        </div>
    )
}

const MainHeader = ({
                        style,
                        className,
                        Title = NullAsDefault,
                        Footer = NullAsDefault,
                        renderFooter = renderSelf,
                    }) => {
    const {isLg} = useContext(LayoutContext)
    const {hidden} = useScrollHide()  // import hook vừa tạo

    const _footerProps = {
        style: {
            zIndex: 999,
            // chỉ animate trên mobile
            ...(!isLg && {
                transition: 'transform 0.5s ease, opacity 0.5s ease',
                transform: hidden ? 'translateY(-100%)' : 'translateY(0)',
                opacity: hidden ? 0 : 1,
                willChange: 'transform',
                pointerEvents: hidden ? 'none' : 'auto',
            }),
        },
        className: 'background PageHeader stickyTop shadow-xs flex items-center',
    }
    return (
        <React.Fragment>
            <Title/>
            {renderFooter(
                <div {..._footerProps}>
                    <Footer/>
                </div>,
                _footerProps
            )}
        </React.Fragment>
    )
}

export const AppHeader = withProps({
    Footer: LogoHeader,
})(MainHeader)

export const RootHeader = withProps({
    Footer: withProps({
        isSubPage: false
    })(LogoHeader),
})(MainHeader)

export default MainHeader
